import React from 'react';
import HomePage from '~src/pages/home';

const App = () => {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
};

export default App;
